import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { ShipmentSearch } from "../dto/shipment/ShipmentSearch";
import { ReadResponse } from '../dto/response/ReadResponse';
import AuthUtility from '../util/AuthUtility';
import { ShipmentEntity } from '../dto/shipment/ShipmentEntity';
import { BaseResponse } from '../dto/response/BaseResponse';
import { ApiClient } from '../util/ApiUtility';

export const onShipmentSearch = async (data: ShipmentSearch) => {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/shipment',
      params: {
        id: data.id,
        driverPhoneNo: data.driverPhoneNo,
        status: data.status,
        offset: data.offset,
        limit: data.limit
      }
    }
    const response = await ApiClient().request<ReadResponse>(requestConfig);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Амжилтгүй");
    }
  }

  export const shipmentUpdate = async (shipment: ShipmentEntity) => {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/shipment/update',
      data: shipment
    }
    console.log(1, shipment)
    const response = await ApiClient().request<BaseResponse<ShipmentEntity>>(requestConfig);
    console.log(2, response);
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
  }